/**
 * @props icon: Icon to be displayed on the card. (name of the icon)
 * @props title: Title of the card. (string)
 * @props subText: To show more information on the card. (string)
 * @props linkButtonText: Text of the button (string)
 * @props alignItems: To align the items on the card (string: all the available properties of align-items)
 * @props justifyContent: To align the items on the card (string: all the available properties of justify-content)
 * @props isHighlighted: To show the green border on the card. It will also show the checkbox icon on the top right side (boolean)
 * @props fullWidth: Allows card to aquire full width of it's parent. (boolean)
 */

import React from "react";
import { HEADING } from "../../heading/constants/constants";
import Heading from "../../heading/Heading";
import Icons from "../../icons/Icons";
import BasicCard from "../basiccard/BasicCard";
import styles from "./CardWIconTitleAndButton.styles";

export default function CardWIconTitleAndButton({
  icon,
  title,
  subText,
  alignItems,
  justifyContent,
  linkButtonText,
  isHighlighted = false,
  customStyles = {},
  headerCustomStyles = {},
  fullWidth = false,
  onClickLinkButtonTextCb = () => { }
}) {
  return (
    <>
      <BasicCard
        isHighlighted={isHighlighted}
        customStyles={{ ...customStyles }}
        fullWidth={fullWidth}
        alignItems={alignItems}
        justifyContent={justifyContent}
      >
        {icon && (
          <div>
            <Icons familyName="vec" iconName={icon} />
          </div>
        )}

        {title && (
          <Heading type={HEADING.H2} customStyle={{ ...styles.cardTitle, ...headerCustomStyles }}>
            {title}
          </Heading>
        )}

        {subText && <p>{subText}</p>}

        {linkButtonText && (
          <button style={{ ...styles.cardButton }} onClick={onClickLinkButtonTextCb}>{linkButtonText}</button>
        )}
      </BasicCard>
    </>
  );
}
